export const SEGMENT_CONTROL_PARTS = [
  'container',
  'segmentButton',
  'segmentContainer',
] as const;
